import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSardinia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_999)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.7391 4.17389C16.7667 4.17389 15.9496 4.839 15.7179 5.73909L17.7391 6.26081L19.7603 5.73909C19.5287 4.83905 18.7116 4.17389 17.7391 4.17389Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6522 8.86955L18.2609 9.39127V8.28207C18.9942 8.09326 19.5714 7.5159 19.7602 6.78258L17.7391 6.26086H15.1305L15.6522 7.82607V8.86955Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7603 5.73914H15.1305V6.78262V7.8261H15.6522V6.78262H19.7602C19.8031 6.61589 19.8261 6.44104 19.8261 6.2609C19.8261 6.08071 19.8033 5.90587 19.7603 5.73914Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78262 4.17389C5.81016 4.17389 4.99308 4.839 4.76142 5.73909L6.78262 6.26081L8.80383 5.73909C8.57217 4.83905 7.75509 4.17389 6.78262 4.17389Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.69566 8.86955L7.30434 9.39127V8.28207C8.0377 8.09326 8.61492 7.5159 8.80369 6.78258L6.78262 6.26086H4.17389L4.69561 7.82607V8.86955H4.69566Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.80383 5.73914H4.17389V6.78262V7.8261H4.69561V6.78262H8.80364C8.84658 6.61589 8.86954 6.44104 8.86954 6.2609C8.86954 6.08071 8.84676 5.90587 8.80383 5.73914Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.7391 14.6087C16.7667 14.6087 15.9496 15.2738 15.7179 16.1739L17.7391 16.6956L19.7603 16.1739C19.5287 15.2738 18.7116 14.6087 17.7391 14.6087Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.6522 19.3043L18.2609 19.8261V18.7169C18.9942 18.528 19.5714 17.9507 19.7602 17.2174L17.7391 16.6956H15.1305L15.6522 18.2609V19.3043Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7603 16.1739H15.1305V17.2174V18.2609H15.6522V17.2174H19.7602C19.8031 17.0506 19.8261 16.8758 19.8261 16.6957C19.8261 16.5155 19.8033 16.3407 19.7603 16.1739Z",
				fill: "#ACABB1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78262 14.6087C5.81016 14.6087 4.99308 15.2738 4.76142 16.1739L6.78262 16.6956L8.80383 16.1739C8.57217 15.2738 7.75509 14.6087 6.78262 14.6087Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.69566 19.3043L7.30434 19.8261V18.7169C8.0377 18.528 8.61492 17.9507 8.80369 17.2174L6.78262 16.6956H4.17389L4.69561 18.2609V19.3043H4.69566Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.80383 16.1739H4.17389V17.2174V18.2609H4.69561V17.2174H8.80364C8.84658 17.0506 8.86954 16.8758 8.86954 16.6957C8.86954 16.5155 8.84676 16.3407 8.80383 16.1739Z",
				fill: "#ACABB1"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_999",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSardinia;
